import { render, staticRenderFns } from "./_base-view.vue?vue&type=template&id=2c7bc21f&"
import script from "./_base-view.vue?vue&type=script&lang=js&"
export * from "./_base-view.vue?vue&type=script&lang=js&"
import style0 from "./_base-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports